export default __webpack_public_path__ + "static/kosmonautaLogo-c1aa64918f3331a82217661bf2a9b12f.png";